export const LIFE_QUOTE_STEP_KEYS = {
  PERSONAL_DETAILS: "personalDetails",
  TERM_DETAILS: "termDetails",
  QUOTE_SELECTION: "quoteSelection",
  DOCUMENT_UPLOAD: "documentUpload",
  PAYMENT: "payment",
} as const;

type StaticOption = { label: string; value: string };

export const LIFE_STATIC_OPTIONS: Record<string, StaticOption[]> = {
  planOption: [
    { label: "Life Cover", value: "life_cover" },
    { label: "Extra Life Option", value: "extra_life_option" },
  ],
  policyTerm: [
    { label: "Upto age 55", value: "upto_age_55" },
    { label: "Upto age 60", value: "upto_age_60" },
    { label: "Upto age 65", value: "upto_age_65" },
    { label: "Upto age 70", value: "upto_age_70" },
  ],
  premiumPaymentTerm: [
    { label: "Upto age 60", value: "upto_age_60" },
    { label: "5", value: "5" },
    { label: "10", value: "10" },
    { label: "15", value: "15" },
  ],
  premiumPaymentFrequency: [
    { label: "Monthly", value: "monthly" },
    { label: "Quarterly", value: "quarterly" },
    { label: "Half yearly", value: "half_yearly" },
    { label: "Annually", value: "annually" },
  ],
  category: [
    { label: "General", value: "general" },
    { label: "Staff", value: "staff" },
  ],
  payoutType: [
    { label: "Lumpsum", value: "lumpsum" },
    { label: "Fixed Income", value: "fixed_income" },
    { label: "Mixed", value: "mixed" },
  ],
  payoutTerm: [
    { label: "60 Months", value: "60" },
    { label: "120 Months", value: "120" },
  ],
};
